import React, { useState, useEffect, useCallback } from 'react';
import './PullToRefresh.css';

const PullToRefresh = ({ onRefresh, children }) => {
    const [pullDistance, setPullDistance] = useState(0);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [startY, setStartY] = useState(0);

    const PULL_THRESHOLD = 80; 

    const handleTouchStart = (e) => {
    
        if (window.scrollY === 0) {
            setStartY(e.touches[0].pageY);
        }
    };

    const handleTouchMove = useCallback((e) => {
        if (startY === 0 || isRefreshing) return;

        const currentY = e.touches[0].pageY;
        const diff = currentY - startY;

        if (diff > 0) {
            
            const distance = Math.min(diff * 0.4, PULL_THRESHOLD + 20);
            setPullDistance(distance);

            //プルが一定以上の距離を超えた場合、ブラウザのデフォルトの引っ張り更新動作を防止
            if (diff > 10 && e.cancelable) {
                e.preventDefault();
            }
        }
    }, [startY, isRefreshing]);

    const handleTouchEnd = async () => {
        if (pullDistance >= PULL_THRESHOLD && !isRefreshing) {
            setIsRefreshing(true);
            setPullDistance(40); 

            if (onRefresh) {
                await onRefresh();
            }

            // リフレッシュ完了後、アイコンをフェードアウトさせてから元に戻す
            setTimeout(() => {
                setIsRefreshing(false);
                setPullDistance(0);
            }, 500);
        } else {
            setPullDistance(0);
        }
        setStartY(0);
    };

    return (
        <div 
            className="ptr-container"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            {/* アイコン表示 */}
            <div 
                className="ptr-indicator" 
                style={{ 
                    height: `${pullDistance}px`,
                    opacity: pullDistance > 10 ? 1 : 0,
                    transition: pullDistance === 0 || pullDistance === 40 ? 'all 0.3s ease' : 'none'
                }}
            >
                {isRefreshing ? (
                    <div className="ptr-spinner"></div>
                ) : (
                    <div className="ptr-message" style={{ transform: `rotate(${pullDistance * 2}deg)` }}>
                        ↓
                    </div>
                )}
            </div>

            
            <div 
                className="ptr-content"
                style={{ 
                    transform: `translateY(${pullDistance}px)`,
                    transition: pullDistance === 0 || pullDistance === 40 ? 'all 0.3s ease' : 'none'
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default PullToRefresh;